import { Component, EventEmitter, Input, Output } from '@angular/core';
import { ErrorNotificationComponent } from '@components/error-notification/error-notification.component';
import { ExternalPayment, NgxPaymentExternalPayButtonComponent, Payment, PaymentError } from '@medology/ngx-payment';

@Component({
  selector: 'app-payment-submit-button',
  templateUrl: './payment-submit-button.component.html',
  styleUrls: ['./payment-submit-button.component.scss'],
  imports: [ErrorNotificationComponent, NgxPaymentExternalPayButtonComponent],
})
export class PaymentSubmitButtonComponent {
  @Input() public processing: boolean = false;
  @Input() public payments: Payment[] = [];
  @Input() public buttonText: string = 'Continue';
  @Input() public displayTrustBadge: boolean = true;
  @Input() public validationError: Error | null = null;
  @Input() public submissionErrors: (string | Error)[] = [];
  @Input() public submitButtonClass: string = 'has-background-orange';

  @Output() public submissionErrorsChange = new EventEmitter<(string | Error)[]>();

  @Output() public paymentSubmitted = new EventEmitter<void>();

  /**
   * Returns the first external payment method from the payments list, or null if none is present.
   */
  public get externalPayment(): ExternalPayment | null {
    return this.payments.find((p): p is ExternalPayment => p instanceof ExternalPayment) ?? null;
  }

  /**
   * Returns the submission errors as plain strings, extracting the message from any Error instances.
   */
  public get submissionErrorMessages(): string[] {
    return this.submissionErrors.map((error) => (error instanceof Error ? error.message : error));
  }

  /**
   * Handles form submission by emitting the paymentSubmitted event.
   */
  public onSubmit(): void {
    this.paymentSubmitted.emit();
  }

  /**
   * Handles payment errors by setting the submission errors.
   *
   * @param {PaymentError} error the payment error
   */
  public onPaymentError(error: PaymentError): void {
    this.submissionErrors = [error.message];
    this.submissionErrorsChange.emit(this.submissionErrors);
  }
}
